module.exports = __webpack_public_path__ + "img/problem3.fb8376bc.png";